export const customObjectsCustomObjectTypeSchema = "/custom_objects/custom_object_type_schema" as const;
